import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import ReactDOM from 'react-dom/client';
import { Box, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const ZoomUI = ({ map }) => {
    const handleZoomIn = () => {
        map.zoomIn();
    };

    const handleZoomOut = () => {
        map.zoomOut();
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
        }}>
            <IconButton
                onClick={handleZoomIn}
                sx={{
                    background: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.15)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #1a7a93 0%, #5bc3de 100%)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.25)',
                    },
                    '&:active': {
                        transform: 'translateY(0)',
                    }
                }}
            >
                <AddIcon sx={{ fontSize: 20 }} />
            </IconButton>
            <IconButton
                onClick={handleZoomOut}
                sx={{
                    background: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
                    color: 'white',
                    width: '36px',
                    height: '36px',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.15)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #1a7a93 0%, #5bc3de 100%)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 20px 0 rgba(0, 0, 0, 0.25)',
                    },
                    '&:active': {
                        transform: 'translateY(0)',
                    }
                }}
            >
                <RemoveIcon sx={{ fontSize: 20 }} />
            </IconButton>
        </Box>
    );
};

const CustomZoomControl = () => {
    const map = useMap();

    useEffect(() => {
        if (!map) return;

        map.zoomControl.remove();

        const control = L.control({ position: 'topleft' });

        control.onAdd = () => {
            const div = L.DomUtil.create('div', 'leaflet-custom-zoom');
            L.DomEvent.disableClickPropagation(div);
            L.DomEvent.disableScrollPropagation(div);
            const root = ReactDOM.createRoot(div);
            root.render(<ZoomUI map={map} />);
            div.reactRoot = root;
            return div;
        };

        control.onRemove = () => {
            const div = control.getContainer();
            if (div && div.reactRoot) {
                queueMicrotask(() => {
                    if (div.reactRoot) {
                        div.reactRoot.unmount();
                        delete div.reactRoot;
                    }
                });
            }
        };

        control.addTo(map);

        return () => {
            if (map && control) {
                map.removeControl(control);
            }
        };
    }, [map]);

    return null;
};

export default CustomZoomControl;
